import React from 'react';

const AdminFooter = () => {
  return (
    <footer className="bg-light border-top py-3 mt-auto">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="text-muted mb-0">
              &copy; 2025 Prathamesh Developers Admin Panel. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <small className="text-muted">Version 1.0.0</small>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AdminFooter;
